import { render } from "./SidebarDashboard.vue?vue&type=template&id=9a92b9a6"
const script = {}

import "./SidebarDashboard.vue?vue&type=style&index=0&id=9a92b9a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__